"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCreatePayoutCXToKapi = void 0;
var uuid_1 = require("uuid");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../../shared/core");
var getCurrencyFromRetailerCurrencyCode = function (currency) {
    return currency === 'GBP' ? __generated__1.CurrencyInput.Gbp : __generated__1.CurrencyInput.Aud;
};
var mapCreatePayoutCXToKapi = function (_a, accountId, customerId) {
    var amount = _a.amount;
    var retailer = core_1.configService.getConfig().retailer;
    return {
        accountId: accountId,
        customerId: customerId,
        paymentServiceProvider: __generated__1.PaymentServiceProvider.Pol,
        idempotencyKey: (0, uuid_1.v4)(),
        amount: {
            currency: getCurrencyFromRetailerCurrencyCode(retailer.currencyCode),
            value: amount.toFixed(2), //KaPI requires amount to have 2 decimal points
        },
    };
};
exports.mapCreatePayoutCXToKapi = mapCreatePayoutCXToKapi;
